
(function(){
  "use strict";
  var STORE=window.location.origin;
  // Shopify variant IDs — FILL IN LATER (one per bundle):
  var VARIANT=(window.PGX_CONFIG||{}).variants||{};
  var sel="opt2";
  var cards=document.getElementById("cards");
  cards.addEventListener("click",function(e){var c=e.target.closest&&e.target.closest(".card");if(!c)return;sel=c.getAttribute("data-k");[].forEach.call(cards.querySelectorAll(".card"),function(x){x.classList.toggle("sel",x===c)});});
  document.getElementById("pgAtc").addEventListener("click",function(){var v=VARIANT[sel];if(!v){alert("Checkout link not set yet for this option. (Shopify variant IDs to be added.)");return;}var destination=/^https?:/.test(v)?v:(STORE+"/cart/"+v+":1");if(window.PrimeGradeFunnelAds)window.PrimeGradeFunnelAds.beginCheckout(destination);else window.location.href=destination;});
  var cd=document.getElementById("cd"),t=300;setInterval(function(){if(t>0)t--;var mm=Math.floor(t/60),ss=t%60;cd.textContent=(mm<10?"0":"")+mm+":"+(ss<10?"0":"")+ss;},1000);
})();
